import Vue from "vue"
import Vuex from "vuex"
import VuexORM from "@vuex-orm/core"
import VuexORMAxios from "@vuex-orm/plugin-axios"
import Student from "@/models/Student"
import Assistant from "@/models/Assistant"
import StudentCourse from "@/models/StudentCourse"
import Course from "@/models/Course"
import Presence from "@/models/Presence"
import Checkin from "@/models/Checkin"
import Evaluation from "@/models/Evaluation"
import User from "@/models/User"
import ConnectedUser from "@/models/ConnectedUser"
import Education from "@/models/Education"
import Description from "@/models/Description"
import Note from "@/models/Note"
import axios from "axios"
import Auth from "@/store/Auth.js"
import { notify } from "@/services/notification"
import { refreshCSRFToken } from "@/services/auth"

Vue.use(Vuex)

// Response interceptor to handle 401 and 419 errors
const unauthorizedInterceptor = async (error) => {
  if (!error || !error.response) {
    notify("error", error)
    return Promise.reject(error)
  }

  if (error.response.status >= 500) {
    notify("error", error)
    return Promise.reject(error)
  }

  if (error.response.status === 401) {
    // Handle unauthorized errors (redirect to login)
    location.href = "/login"
    return
  }

  if (error.response.status === 419) {
    // Handle CSRF token expiration
    try {
      const newToken = await refreshCSRFToken()
      error.config.headers["X-CSRF-TOKEN"] = newToken // Set new CSRF token on the original request
      return axiosInstance(error.config) // Retry the original request with the new token
    } catch (refreshError) {
      notify("error", refreshError)
      return Promise.reject(refreshError)
    }
  }

  return Promise.reject(error)
}

const axiosInstance = axios.create({})
axiosInstance.interceptors.response.use((response) => response, unauthorizedInterceptor)

VuexORM.use(VuexORMAxios, { axios })

const database = new VuexORM.Database()
database.register(Student)
database.register(StudentCourse)
database.register(Assistant)
database.register(Course)
database.register(Presence)
database.register(Checkin)
database.register(Evaluation)
database.register(User)
database.register(ConnectedUser)
database.register(Education)
database.register(Description)
database.register(Note)

const store = new Vuex.Store({
  modules: {
    Auth,
  },
  plugins: [VuexORM.install(database)],
})

export default store
